// Hooks
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
///// Umiverse Imports
// Redux
import { selectActiveProjectId } from 'src/redux/slices/project/selectors'
import { getBuildingCount } from 'src/redux/slices/umibuilder/endpoints'
import { changeArchetypeID } from 'src/redux/slices/umibuilder/reducers'
import { selectUmiBuilderFromCloud } from 'src/redux/slices/umibuilder/selectors'
import { TextFieldOnChangeEvent } from 'src/types/event-handlers'

// MUI
import Grid from '@material-ui/core/Grid'
import LinearProgress from '@material-ui/core/LinearProgress'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

type SecondaryFieldGroupProps = {
  secondaryMin: number
  secondaryMax: number
  archetypeID: string
  primaryField: string
  index: number
  archetypeIDs: string[]
}

const SecondaryFieldGroup: React.FC<SecondaryFieldGroupProps> = ({
  secondaryMin,
  secondaryMax,
  archetypeID,
  primaryField,
  index,
  archetypeIDs,
}) => {
  const dispatch = useDispatch()
  const fromCloud = useSelector(selectUmiBuilderFromCloud)
  const projectId = useSelector(selectActiveProjectId)
  const { buildingCounts, count } = getBuildingCount.useQuery(
    { fromCloud, projectId },
    {
      selectFromResult: ({ data }) => {
        const buildingCounts = data?.[primaryField]
        const count = buildingCounts?.[index]
        return { buildingCounts, count }
      },
    },
  )

  const staleBuildingCounts = buildingCounts?.length !== archetypeIDs.length

  const updateID = useCallback(
    (e: TextFieldOnChangeEvent) => {
      dispatch(
        changeArchetypeID({
          index,
          field: primaryField,
          archetypeID: e.target.value.replaceAll(' ', '_'),
        }),
      )
    },
    [index, primaryField],
  )

  // TODO: This should handle ALL ids, pull it in via a selector
  const error = archetypeIDs.filter((id) => id === archetypeID).length > 1

  return (
    <>
      <Grid item xs={4}>
        <TextField
          value={archetypeID}
          onChange={updateID}
          fullWidth={true}
          error={error}
          helperText={error ? 'Duplicate IDs not allowed' : 'Enter an archetype ID'}
        />
      </Grid>
      <Grid item xs={2} justifyContent='center' container>
        <Typography variant='overline'>
          {secondaryMin} - {secondaryMax}
        </Typography>
      </Grid>
      <Grid item xs={4} justifyContent='center' container>
        {staleBuildingCounts ? (
          <LinearProgress />
        ) : (
          <Typography variant='overline'>{count}</Typography>
        )}
      </Grid>
    </>
  )
}

export default SecondaryFieldGroup
